import { useEffect, useState, useCallback } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { MachineGroup, Title, GroupFamily, NavLink } from "../NavbarStyles";
import { AOO_API_HOST } from "../../../env";
import Routes from "../../Data/Routes";

function Groups() {
  const navigate = useNavigate();
  const [result, setResult] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const url = `${AOO_API_HOST}/aoo-api/Productions/machine-groups`;

  const fetchMachines = useCallback(async () => {
    try {
      setLoading(true);
      const response = await axios.get(url);
      setResult(response.data);
    } catch (err) {
      setError("Failed to fetch machine groups. Please try again later.");
    } finally {
      setLoading(false);
    }
  }, [url]);

  useEffect(() => {
    fetchMachines();
  }, [fetchMachines]);

  const handleClick = useCallback(
    (group) => {
      navigate(Routes.MainRemoteMachine, { state: group });
    },
    [navigate]
  );

  return (
    <GroupFamily>
      <NavLink
        onClick={() => navigate(Routes.MainRemote)}
        style={{ marginRight: 30 }}
      >
        Back to menu
      </NavLink>

      <Title>Choose machine group</Title>

      {loading && <p>Loading...</p>}
      {error && <p style={{ color: "red" }}>{error}</p>}

      {!loading && !error && (
        <>
          <MachineGroup onClick={() => handleClick(" ")}>All</MachineGroup>
          {result.map((group) => (
            <MachineGroup key={group.Id} onClick={() => handleClick(group.Id)}>
              {group.GroupName?.length !== 1 ? group.GroupName : "(none)"}
            </MachineGroup>
          ))}
        </>
      )}
    </GroupFamily>
  );
}

export default Groups;
